// Who he is, for anything a person reads.
//
// He answers to Pino now. His INTERNAL id is still `victor` and must stay that
// way: it keys his persona file, his memory and daily logs on the Pi, the
// journal endpoints, the offerings rows in Neon, and the npc id on the wire.
// Renaming those would cost him his continuity for no visible gain, so the
// rename lives here and nowhere else.
//
// Import BIRD_NAME anywhere a name is shown. Never hardcode either spelling.
export const BIRD_NAME = 'Pino'

// The id used on the wire, in the DB, and on disk. Not for display.
export const BIRD_ID = 'victor'
